import React from "react";
import domcamera from "../../Images/domcamera-removebg-preview.png";
import kuberindustries from "../../Images/ManglamCity/kuberindustries.png";
import locationgif from "../../Images/LOCATIONGIF.png";
import kiaservicecenter from "../../Images/ManglamCity/kiaservicecenter.jpg";
import vanasthalihostel from "../../Images/ManglamCity/vanasthali.png";
import CountUp from "react-countup";
export default function Login() {
  return (
    <>
      <section className="camera-section">
        {/*-------------------------------------------- CAMERA SECTION IMAGE ------------------------------------------------------*/}
        <div className="container text-center camera-main-title">
          <h1 className="camera-main-name">Camera's</h1>
          <img
            src={domcamera}
            alt="domcameraimage"
            className="dom-camera-img"
            style={{ marginTop: 5 + "px" }}
          />
        </div>
        {/*-------------------------------------------- CAMERA SECTION IMAGE ------------------------------------------------------*/}

        <div
          className="container-fluid text-center"
          style={{
            backgroundColor: "black",
            height: "justify",
            marginTop: 5 + "vh",
          }}
        >
          <div
            className="container"
            style={{ color: "white", padding: 1 + "vh" }}
          >
            {/*-------------------------------------------------- Card 1 -------------------------------------------------------------*/}

            <div
              className="card mb-2 camerasection-card"
              style={{ backgroundColor: "black", color: "white" }}
            >
              <div className="row">
                <div className="col col-md-6 col-sm-12 col-lg-6">
                  <img
                    src="https://content.jdmagicbox.com/comp/jamshedpur/b1/0657px657.x657.210111124324.r2b1/catalogue/-53qk33x4ly.jpg?clr="
                    className="cam-sec-image "
                    style={{ borderRadius: 2 + "vh" }}
                    alt="..."
                  />
                </div>

                <div className="col-md-6 col-sm-12 col-lg-6" style={{ padding: 2 + "vh" }}>
                  <div className="card-body">
                    <h1 className="card-title">Over 250 +</h1>
                    <p className="card-text">
                      <h5>
                        CCTV'S Installed at Manglam Residency
                        <br />{" "}
                      </h5>
                      <br></br> Location : 200 Ft Main Road, Adjacent To Manglam
                      Tarang Muhana, Mandi Road, Mansarovar, Jaipur{" "}
                    </p>

                    <p className="card-text">
                      <small className="text-body-secondary">
                        <a href="https://goo.gl/maps/qgatwqyTifH4cP6o6">
                          <img
                            src={locationgif}
                            alt=""
                            className="location-gif"
                            data-bs-toggle="tooltip"
                            data-bs-title="Another one here too"
                            href="#"
                          />
                        </a>
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/*-------------------------------------------------- Card 2 Start '---------------------------------------------------------*/}

            <hr
              style={{
                height: 20 + "px",
                borderWidth: 2 + "px",
                color: "white",
                borderColor: "white",
              }}
            ></hr>

            <div
              className="card mb-3 camerasection-card"
              style={{ backgroundColor: "black", color: "white" }}
            >
              <div className="row g-0">
                <div className="col-md-6 col-lg-6 col-sm-12 ">
                  <img
                    src={kuberindustries}
                    className="cam-sec-image img-fluid "
                    style={{ borderRadius: 2 + "vh" }}
                    alt="..."
                  />
                </div>

                <div className="col-md-6 col-lg-6 col-sm-12" style={{ padding: 2 + "vh" }}>
                  <div className="card-body">
                    <h1 className="card-title">Over <CountUp end={80} duration={5} loop/> + </h1>
                    <p className="card-text">
                      <h5>
                        CCTV'S Installed at Kuber Mart Idustries Pvt Ltd
                        <br />{" "}
                      </h5>
                      <br></br> Location : A-183 Prahladpura, Industrial Area,
                      Jaipur, Rajasthan 303903{" "}
                    </p>

                    <p className="card-text">
                      <small className="text-body-secondary">
                        <a href="https://maps.app.goo.gl/rVibuabNSgUFejSq8">
                          <img
                            src={locationgif}
                            alt=""
                            className="location-gif"
                            data-bs-toggle="tooltip"
                            data-bs-title="Another one here too"
                            href="#"
                          />
                        </a>
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/*-------------------------------------------------- Card 3 Start '---------------------------------------------------------*/}

            <hr
              style={{
                height: 20 + "px",
                borderWidth: 2 + "px",
                color: "white",
                borderColor: "white",
              }}
            ></hr>

            <div
              className="card mb-5 camerasection-card"
              style={{ backgroundColor: "black", color: "white" }}
            >
              <div className="row g-0">
                <div className="col-md-6 col-lg-6 col-sm-12">
                  <img
                    src={kiaservicecenter}
                    className="cam-sec-image img-fluid "
                    style={{ borderRadius: 2 + "vh" }}
                    alt="..."
                  />
                </div>

                <div className="col-md-6 col-lg-6 col-sm-12" >
                  <div className="card-body">
                    <h1 className="card-title">Over 40+ </h1>
                    <p className="card-text">
                      <h5>
                        CCTV'S Installed at ( KIA ) Service Center
                        <br />{" "}
                      </h5>
                      <br></br> Location : 37, Jhotwara Industrial Area,
                      Jhotwara, Jaipur, Rajasthan 302022{" "}
                    </p>

                    <p className="card-text">
                      <small className="text-body-secondary">
                        <a href="https://goo.gl/maps/Pk4oRo1dprUHcmpk7">
                          <img
                            src={locationgif}
                            alt=""
                            className="location-gif"
                            data-bs-toggle="tooltip"
                            data-bs-title="Another one here too"
                            href="#"
                          />
                        </a>
                      </small>
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/*-------------------------------------------------- Card 4 Start '---------------------------------------------------------*/}

            <hr
              style={{
                height: 20 + "px",
                borderWidth: 2 + "px",
                color: "white",
                borderColor: "white",
              }}
            ></hr>

            <div
              className="card mb-5 camerasection-card"
              style={{ backgroundColor: "black", color: "white" }}
            >
              <div className="row g-0">
                <div className="col-md-6 col-lg-6 col-sm-12">
                  <img
                    src={vanasthalihostel}
                    className="cam-sec-image img-fluid "
                    style={{ borderRadius: 2 + "vh" }}
                    alt="..."
                  />
                </div>

                <div className="col-md-6 col-lg-6 col-sm-12" style={{ padding: 2 + "vh" }}>
                  <div className="card-body">
                    <h1 className="card-title">Over 50+ </h1>
                    <p className="card-text">
                      <h5>
                        CCTV'S Installed at Vanasthali Residency <br />{" "}
                      </h5>
                      <br></br> Location : A-11, Rd Number 1, adjacent to Gaurav
                      Tower, Indraprastha Industrial Area
                      <br /> Kota, Rajasthan 324005{" "}
                    </p>

                    <p className="card-text">
                      <small className="text-body-secondary">
                        <a href="https://goo.gl/maps/HHfBLBvUx8Qz4HdC7">
                          <img
                            src={locationgif}
                            alt=""
                            className="location-gif"
                            data-bs-toggle="tooltip"
                            data-bs-title="Another one here too"
                            href="#"
                          />
                        </a>
                      </small>
                    </p>
                  </div>
                </div>
              </div>
              <hr
                style={{
                  height: 5 + "px",
                  borderWidth: 2 + "px",
                  color: "white",
                  borderColor: "white",
                }}
              ></hr>
            </div>
          </div>

          <h1>Happy customer's over 500+</h1>
          <h4 style={{ marginBottom: 20 + "vh" }}>Your place our work!!</h4>
        </div>
      </section>
    </>
  );
}
